import React, { Fragment, useMemo } from "react";
import InputField from "components/form/InputField";
import Button from "components/form/Button";
import { CancelReason } from "types/subscriptionAndPlans";

interface ReasonPopupProps {
  reasons: CancelReason[];
  message: string;
  isBTNLoading: boolean;
  getDisableStatus: () => boolean;
  handleCheckReason: (
    e: React.ChangeEvent<HTMLInputElement> | boolean,
    data: CancelReason,
    isTitle: boolean,
  ) => void;
  setMessage: (msg: string) => void;
  handleCancelPlan: (args: { btn: "noThanks" | "submit" }) => void;
}

const ReasonPopup: React.FC<ReasonPopupProps> = ({
  reasons,
  message,
  isBTNLoading,
  getDisableStatus,
  handleCheckReason,
  setMessage,
  handleCancelPlan,
}) => {
  const isOtherReasonVisible = useMemo(
    () => reasons.some((item) => item.value === "other_reason" && item.display),
    [reasons]
  );

  const isErr = useMemo(() => {
    if (
      reasons.some((item) => item.checked && item.value === "other_reason") &&
      message.length > 120
    ) {
      return true;
    }
    return false;
  }, [message, reasons]);
  return (
    <Fragment>
      <div className="pt-5 lg:text-xl text-txtPrimary lg:leading-[30px] leading-[24px]">
        We would love your feedback - tell us why you canceled this plan
      </div>
      <div className="pt-5 lg:text-lg text-sm text-txtPrimary leading-[23.44px] flex flex-col lg:gap-6 md:gap-5 gap-4">
        {reasons?.map((item, index) => (
          <React.Fragment key={index}>
            {item.display ? (
              <div className="w-full flex gap-4 justify-start items-center">
                <input
                  type="radio"
                  checked={item.checked}
                  className="dcdial_radio cursor-pointer"
                  onChange={(e) => handleCheckReason(e, item, false)}
                />
                <span
                  className="cursor-pointer"
                  onClick={() => {
                    handleCheckReason(true, item, true);
                  }}
                >
                  {item.title}
                </span>
              </div>
            ) : null}
          </React.Fragment>
        ))}
      </div>
      {isOtherReasonVisible && (
        <div className="pt-5 w-full">
          <InputField
            name="message"
            textarea
            placeholder="Please provide your reason"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="lg:h-[140px] h-[130px]"
            _className="text-sm"
            customStyle={{ resize: "none" }}
          />
          {isErr && (
            <p className="text-red text-xs mt-1">
              Please limit your response to 120 characters.
            </p>
          )}
        </div>
      )}
      <div className="lg:pt-[30px] pt-5 w-full flex lg:justify-end justify-center item-end gap-5">
        <Button
          text="No, thanks"
          variant="white"
          className="lg:w-fit w-full"
          isDisabled={isBTNLoading}
          onClick={() => handleCancelPlan({ btn: "noThanks" })}
        />
        <Button
          text="Submit"
          className="lg:w-fit w-full"
          isDisabled={getDisableStatus() || isErr}
          onClick={() => handleCancelPlan({ btn: "submit" })}
          isLoading={isBTNLoading}
        />
      </div>
    </Fragment>
  );
};

export default ReasonPopup;
